import React from 'react';
import { Avatar, Box, Text, Flex, useTheme } from 'native-base';
import { useAuthState } from '../../context/auth';
import { useEnvState } from '../../context/env';
import { AVATAR_SIZE } from '../Constants';
const SearchResultItem = ({
  user,
  navigation
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const envState = useEnvState();
  const authState = useAuthState();
  const {
    username,
    name,
    avatar_template
  } = user;
  const moderatorColor = colors.searchResultItem.moderator;
  const authUserName = `${envState.discourse_api_username_prefix}.${authState.platform_user_id}`;
  let avatarTemplate = envState.base_url + user.avatar_template.replace(/\{size\}/, AVATAR_SIZE);
  return /*#__PURE__*/React.createElement(Box, {
    my: 1,
    px: 4
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Avatar, {
    id: `dm-user-avatar-${username}`,
    source: {
      uri: avatarTemplate
    },
    size: 'sm',
    mr: 2,
    ml: -1
  }, "User Profile Image"), /*#__PURE__*/React.createElement(Text, {
    color: user.moderator ? moderatorColor : '#000',
    fontWeight: 'bold'
  }, name)));
};
export default SearchResultItem;
//# sourceMappingURL=SearchResultItem.js.map